import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Onboarding template to be filled when instantiated
 */
export class OnboardingComponent {}
